import { isValidEmailAddress, uniqueEmailAddresses } from './email.js';
export function resolveBccAddresses(ownershipEmail, choice) {
    const profileEmail = ownershipEmail.trim();
    if (choice.includeOwnershipEmail && !isValidEmailAddress(profileEmail)) {
        return { ok: false, reason: 'ownership_email_invalid' };
    }
    const addresses = uniqueEmailAddresses([
        ...(choice.includeOwnershipEmail ? [profileEmail] : []),
        ...choice.otherAddresses,
    ]);
    return { ok: true, addresses };
}
//# sourceMappingURL=distributionBcc.js.map